module.exports = __webpack_public_path__ + "static/img/performance_4.3524d1d4.jpg";